<div
  [ngClass]="{
    input: !(formControl.invalid && formControl.touched),
    'input-error': formControl.invalid && formControl.touched
  }"
>
  <div class="file-upload-container">
    <label
      [for]="'file-upload' + positionIndex"
      class="custom-file-upload"
      [ngClass]="{ disabled: fileName && !error }"
    >
      <span [ngClass]="{ 'margin-left': isLoading }">{{ label }}</span>
      @if (isLoading) {
        <i class="pi icon pi-spinner pi-spin"></i>
      }
    </label>

    <input
      [id]="'file-upload' + positionIndex"
      type="file"
      [disabled]="fileName && !error"
      (change)="onFileChange($event)"
    />

    @if (fileName && !error) {
      <div>
        <p>
          Archivo seleccionado: {{ fileName }}
          <button
            class="pi pi-times"
            (click)="cancel()"
            type="button"
            aria-label="Cancel file upload"
          ></button>
        </p>
      </div>
    }
    @if (error) {
      <div class="error">
        <p>Ocurrio un error al cargar el archivo</p>
      </div>
    }
    @if (formControl.hasError('invalidType')) {
      <div class="error">
        <p>El tipo de archivo no es valido</p>
      </div>
    }
    @if (formControl.hasError('invalidSize')) {
      <div class="error">
        <p>El tamaño del archivo excede el limite permitido</p>
      </div>
    }
  </div>
  @if (formControl.invalid && formControl.touched) {
    <div>
      @if (formControl.errors?.['required']) {
        <div class="input-error">Este campo es requerido</div>
      }
    </div>
  }
</div>
